import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchContactMessage, fetchContactMessages, updateContactStatus } from "../api/contactApi";
import type { ContactMessageStatus } from "../types";

const QUERY_KEY = ["contact-messages"];

export const useContactMessagesQuery = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchContactMessages,
  });
};

export const useContactMessageQuery = (id: string | null) => {
  return useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => fetchContactMessage(id!),
    enabled: !!id,
  });
};

export const useUpdateContactStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: ContactMessageStatus }) =>
      updateContactStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
